import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../../constants/colors.mjs';
import { factory } from '../../../factory/factory.utils.mjs';
import { Typography } from '../../../Foundations/Typography/Typography.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import '../DatesProvider/DatesProvider.mjs';
import { useDatesContext } from '../DatesProvider/use-dates-context.mjs';
import classes from './WeekdaysRow.module.css.mjs';
import { getWeekdayNames } from './WeekdaysRow.utils.mjs';

const WeekdaysRow = factory((props, ref) => {
  const { className, locale, firstDayOfWeek, weekdayFormat, cellComponent = "th", ...rest } = props;
  const ctx = useDatesContext();
  const weekdays = getWeekdayNames({
    locale: ctx.getLocale(locale),
    format: weekdayFormat,
    firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek)
  }).map((weekday, index) => /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: cellComponent,
      key: index,
      size: "label-regular-s",
      textColor: DsmColor.ContentSecondary,
      paddingBlock: 5,
      scope: "col",
      className: classes.weekday
    },
    weekday
  ));
  return /* @__PURE__ */ React.createElement(Box, { className: clsx(className, classes.weekdaysRow), component: "tr", ref, ...rest }, weekdays);
});

export { WeekdaysRow };
